export const ua = navigator.userAgent;
export const isAndroid = /(?:Android)/.test(ua);
export const isFireFox = /(?:Firefox)/.test(ua);
export const isChrome = /(?:Chrome|CriOS)/.test(ua);
export const isIphone = /(?:iPhone)/.test(ua);
export const isSafari = /(?:Safari)/.test(ua);
// eslint-disable-next-line max-len
export const isTablet = /(?:iPad|PlayBook)/.test(ua) || (isSafari && !isIphone && 'ontouchend' in document) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua));
export const isPc = !isIphone && !isAndroid && !isTablet;
